<template>
  <div
    v-loading.fullscreen.lock="loading"
    class="birthday"
    :element-loading-text="false"
  >
    <div class="tabs clear">
      <a class="fl" :href="`/mall?city=${$route.query.city}`" target="_self">{{TLang('商城首页','my')}}</a>
      <img
        class="fl"
        :src="require('@assets/images/birthday/tab_icon.png')"
        alt=""
      />
      <span class="fl">{{TLang('生日汇','my')}}</span>
    </div>

    <div class="all-category clear">
      <all-brand
        :boutiqueBrandList="boutiqueBrandList || []"
        :virtualGoods="virtualGoodsList[0] || {}"
        :realGoods="realGoodsList[0] || {}"
      />

      <banner-list
        v-if="bannerList && bannerList.length"
        :bannerList="bannerList"
      />
      <div v-if="bannerList.length <= 0 && unionFlag" class="bfd-banner fl">
        <img :src="require('@assets/images/birthday_banner.jpg')" />
      </div>
    </div>

    <div class="brand-list clear">
      <img
        class="fl brand-img"
        :src="require('@assets/images/birthday/brand_img.png')"
        alt=""
      />
      <brand-list
        v-if="brandList.length > 0"
        :brandList="brandList"
        :showHeight="'266px'"
      />
    </div>

    <div class="brand-list clear" v-if="changeBrandList.length > 0">
      <img
        class="fl brand-img changeBrand-img"
        :src="require('@assets/images/birthday/changeBrand_img.png')"
        alt=""
      />
      <brand-list :brandList="changeBrandList" :showHeight="'133px'" />
    </div>

    <goods-list
      v-if="virtualGoodsList && virtualGoodsList.length"
      :name="TLang('电子抵用券', 'my')"
      :type="1"
      :goodsList="virtualGoodsList"
    />

    <goods-list
      v-if="realGoodsList && realGoodsList.length"
      :name="TLang('蛋糕面包西饼', 'my')"
      :type="0"
      :goodsList="realGoodsList"
    />

    <el-dialog
      :title="TLang('选择配送城市', 'my')"
      :visible.sync="curDialogFlag"
      width="900px"
      @close="getCloseDialog"
    >
      <div class="current_city" style="line-height: 36px">
        {{ TLang('当前已选城市','my') }}{{ current_city }}
      </div>
      <default-header-city
        v-show="showCityLayer"
        :allCities="allCities"
        :hotCities="hotCities"
        @cityChange="getCityInfo"
        @hideCityLayer="handeHideCityLayer"
      />
    </el-dialog>
    <!-- <FixedButton :hideCart="true" /> -->
    <FixedButton :channelName="TLang('生日汇', 'my')" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AllBrand from "./allBrand";
import BannerList from "./bannerList";
import BrandList from "./brandList";
import GoodsList from "./goodsList";
import { fetchGoodsTags } from "@fetch";
import { getHomePageData } from "@fetch/birthday";
import { convertTime, unionFlag, toQsPlus } from "@utils";
import FixedButton from "@components/FixedButton";
import DefaultHeaderCity from "@/components/DefaultHeaderCity";
import Cookies from "js-cookie";
import {setTitleInfo} from "@utils/title";
import * as addressApiV2 from "@fetch/addressV2";

export default {
  name: "Birthday",

  components: {
    AllBrand,
    BannerList,
    BrandList,
    GoodsList,
    DefaultHeaderCity,
    FixedButton,
  },

  data() {
    return {
      loading: true,
      bannerList: [],
      brandList: [],
      changeBrandList: [], // 随心兑品牌列表
      boutiqueBrandList: [],
      virtualGoodsList: [],
      realGoodsList: [],
      allCities: [],
      hotCities: [],
      showCityLayer: true,
      curDialogFlag: false,
      current_city: this.TLang('暂未选择', 'my'),
      unionFlag: unionFlag(),
      CookiesOne:Cookies.get('df_lang'),
      addressInfo:
        Cookies.get("address") && JSON.parse(Cookies.get("address") || "{}"),
    };
  },

  beforeRouteEnter(to, from, next) {
    // 设置body背景色
    document.body.classList.add("is-birthday");
    next();
  },

  beforeRouteLeave(to, from, next) {
    // 清除body背景色
    document.body.classList.remove("is-birthday");
    next();
  },
  computed: {
    ...mapGetters("shopCart", ["getCount"]),
    getGoodTagsParams() {
      const goodsList = [];
      this.virtualGoodsList.forEach((good) => {
        if (good.categoryId)
          goodsList.push({
            categoryId: good.categoryId,
            goodsId: good.goodsId,
          });
      });
      this.realGoodsList.forEach((good) => {
        if (good.categoryId)
          goodsList.push({
            categoryId: good.categoryId,
            goodsId: good.goodsId,
          });
      });
      return goodsList;
    },
  },
  created() {
    this.getHomePageData();
    setTitleInfo()
    // 获取城市数据
    if (!Cookies.get("birthdayCity")) {
      this.getCityData();
      this.curDialogFlag = true;
    } else {
      // 更新选择城市弹框cookie剩余时间
      let currentDay = Cookies.get("birthdayDay");
      let disTime = convertTime("24:00:00") - new Date().getTime();
      if (disTime > 0 && currentDay == new Date().getDate()) {
        Cookies.set("birthdayCity", Cookies.get("birthdayCity"), {
          expires: disTime,
        });
      } else {
        Cookies.remove("birthdayCity");
        Cookies.remove("birthdayDay");
        this.getCityData();
        this.curDialogFlag = true;
      }
    }
    this.cartCount({ ...this.addressInfo });
  },

  methods: {
    ...mapActions("shopCart", ["cartCount"]),
    /**
     * 获取首页数据
     * @param { Number } pageSize 每页数据条数 默认12条
     * @param { Number } len 品牌列表一组多少条数据
     */
    async getHomePageData(pageSize = 12, len = 10, changeLen = 5) {
      const res = await getHomePageData({
        pageSize,
      });
      const {
        brandDtos = [],
        goodsDtos = [],
        advertisingRecommendationDtos = [],
        openPayBrandDtos = [],
        pageTemplateInfo = {},
      } = res;
      this.loading = false;
      this.brandList = brandDtos.reduce((prev, cur, index) => {
        if (index % len === 0) {
          prev[parseInt(index / len)] = [];
        }
        prev[parseInt(index / len)].push(cur);
        return prev;
      }, []);
      this.boutiqueBrandList = brandDtos.splice(0, 4) || []; // 精选品牌取前4个
      // 随心兑品牌
      this.changeBrandList = openPayBrandDtos.reduce((prev, cur, index) => {
        if (index % changeLen === 0) {
          prev[parseInt(index / changeLen)] = [];
        }
        prev[parseInt(index / changeLen)].push(cur);
        return prev;
      }, []);
      // 处理banner
      let arr = [];
      if (!this.unionFlag && pageTemplateInfo && pageTemplateInfo.componentLayoutList) {
        arr = this.getBannerInfo(pageTemplateInfo.componentLayoutList)
      }
      console.log('arr', arr)
      this.bannerList = arr && arr.length > 0 ? arr : advertisingRecommendationDtos || [];
      this.virtualGoodsList =
        goodsDtos.filter((item) => item.goodsType === 1) || []; //虚拟产品
      this.realGoodsList =
        goodsDtos.filter((item) => item.goodsType === 0) || []; //实物产品
      this.getGoodsTags();
    },
    getBannerInfo(list) {
      const curAddress = Cookies.get("address") && JSON.parse(Cookies.get("address") || "{}");
      let arrList = [];
      if (list && list.length > 0){
        list.forEach(ele => {
          if (ele.componentCode == 'slider') {
            const content = JSON.parse(ele.content).item.config.list || []
            if (content && content.length > 0) {
              content.forEach(j => {
                let newUrl = j.linkUrl ? toQsPlus(j.linkUrl, {city: curAddress.cityId || 145}) : null
                arrList.push({
                  adImg: j.imgUrl,
                  adUrl: newUrl,
                  isShow: 1,
                })
              })

            }
          }
        })
      }
      return arrList;
    },
    //获取城市信息
    getCityData() {
      this.apis.headerApi.getCityData().then((res) => {
        this.allCities = res.cityList;
        this.hotCities = res.hotCities;
      });
    },
    //关闭dialog
    getCloseDialog() {
      if (!Cookies.get("birthdayCity")) {
        this.$message({
          showClose: true,
          message: this.TLang('请选择配送城市', 'my'),
          type: "error",
        });
        this.curDialogFlag = true;
      } else {
        this.curDialogFlag = false;
      }
    },
    getCityInfo(val) {
      // 每天24点更新cookie
      let disTime = convertTime("24:00:00") - new Date().getTime();
      Cookies.set("birthdayCity", val.name, { expires: disTime });
      Cookies.set("birthdayDay", new Date().getDate(), { expires: 365 });

      this.current_city = this.CookiesOne && this.CookiesOne == 'en-US' ? val.pinyin || val.name : val.name;
      let addressInfo = {};
      addressApiV2.getDefaultAddress({ cityId: val.cityId }).then(({body}) => {
        try {
          addressInfo = {
            provinceId: body.district && body.district.id,
            provinceName: body.district && body.district.name,
            cityName: body.city && body.city.name,
            cityId: body.city && body.city.id,
            regionId: body.region && body.region.id,
            regionName: body.region && body.region.name,
            streetId: body.streets && body.streets.length && body.streets[0].id,
            streetName:
              body.streets && body.streets.length && body.streets[0].name,
          };

          Cookies.set("address", addressInfo), { expires: 365 };
          console.log("Cookies.set4", addressInfo);
          Cookies.set("city", addressInfo.cityId), { expires: 365 };
          setTimeout(() => {
            window.location.reload();
          }, 50);
        } catch (e) {
          console.log(e);
        }
      });
    },
    handeHideCityLayer() {
      this.showCityLayer = false;
    },
    // 商品数据拼接tag
    goodsListAddFlag(res) {
      this.virtualGoodsList.forEach((good) => {
        const goodTag = res.find(
          (tag) =>
            tag.categoryId == good.categoryId && tag.goodsId == good.goodsId
        );
        let tags = goodTag && goodTag.tags ? goodTag.tags : [];
        //type  1特价抢购   满减     2爆炸贴       3新品
        //mktFrontType   1001 特价 1004 抢购  2001 满减  9001 新品
        let newTags = tags.filter(
          (item) =>
            item.type != 2 &&
            item.mktFrontType != 1001 &&
            item.mktFrontType != 1004
        );
        let stickerImgList = tags.filter((item) => item.type === 2);
        const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
        const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
        this.$set(good, "tags", newTags);
        this.$set(good, "promPrice", promPrice);
        this.$set(good, "salePrice", salePrice);
        // 爆炸贴数据
        this.$set(good, "stickerImgList", stickerImgList);
      });
      this.realGoodsList.forEach((good) => {
        const goodTag =
          res.find(
            (tag) =>
              tag.categoryId == good.categoryId && tag.goodsId == good.goodsId
          ) || {};
        let tags = goodTag && goodTag.tags ? goodTag.tags : [];
        // 生日会标签
        //type  1特价抢购   满减     2爆炸贴       3新品
        //mktFrontType   1001 特价 1004 抢购  2001 满减  9001 新品
        let newTags = tags.filter(
          (item) =>
            item.type != 2 &&
            item.mktFrontType != 1001 &&
            item.mktFrontType != 1004
        );
        let stickerImgList = tags.filter((item) => item.type === 2);
        const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
        const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
        const bizStock =
          goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
        this.$set(good, "tags", newTags);
        this.$set(good, "promPrice", promPrice);
        this.$set(good, "salePrice", salePrice);
        this.$set(good, "bizStock", bizStock);
        // 爆炸贴数据
        this.$set(good, "stickerImgList", stickerImgList);
        // 拼接折扣信息
        this.$set(good, "discount", goodTag.discount);
        this.$set(good, "discountPrice", goodTag.discountPrice);
        this.$set(good, "discountTagShow", goodTag.discountTagShow);
        this.$set(good, "mktTagShow", goodTag.mktTagShow);
        // 福拼拼相关字段
        // Y 为福拼拼
        this.$set(good,"groupItem", goodTag.groupItem);
        // groupItemClassStyle 样式 1、文本模式，2、+货币模式
        this.$set(good,"groupItemClassStyle", goodTag.groupItemClassStyle);
        // 拼团价格
        this.$set(good,"groupItemPrice", goodTag.groupItemPrice);
        // 拼团价格限制 最高可抵扣福豆
        this.$set(good,"groupItemPriceLimit", goodTag.groupItemPriceLimit);
        // 拼团商品是否显示人命币 Y:是 N:否
        this.$set(good,"groupItemShowRmbSymbol", goodTag.groupItemShowRmbSymbol );
      });
    },
    // 获取商品tag
    getGoodsTags() {
      if (this.getGoodTagsParams && this.getGoodTagsParams.length > 0) {
        fetchGoodsTags({ goodsList: this.getGoodTagsParams, channel: 2 }).then(
          (res) => {
            if (res && res.length > 0) {
              this.goodsListAddFlag(res);
            }
          }
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.birthday {
  padding: 20px 0 30px 0;
  .tabs {
    font-size: 16px;
    margin-bottom: 20px;
    a {
      width: 100px;
      border: 1px solid #ededed;
      color: #1a4a9e;
      text-align: center;
      line-height: 28px;
      border-radius: 5px;
      &:hover {
        background: #619ee0;
        color: #fff;
      }
    }
    img {
      width: 7px;
      height: 14px;
      margin: 8px 15px 0;
    }
    span {
      width: 100px;
      line-height: 30px;
      color: #fff;
      text-align: center;
      border-radius: 5px;
      background: #619ee0;
    }
  }

  .all-category {
    margin-bottom: 30px;
    .bfd-banner {
      height: 400px;
      width: 900px;
      overflow: hidden;
      img {
        display: block;
        margin: 0;
        width: 100%;
      }
    }
  }

  .brand-list {
    margin-bottom: 30px;
    .brand-img {
      width: 288px;
      height: 267px;
    }
    .changeBrand-img {
      width: 288px;
      height: 134px;
    }
  }
}
</style>
